(function () {
(function() {
    // toggle the thanks that the member wants to give to the post
    $(".member-forum-post-wrapper").on("click", 'i[data-action="thank"]', zeno_debounce(200, function(event) {
        var $this = $(this);
        zeno_ajax_request("/advice/member-forum/actions/thank-post", {
            "forumPostID": $this.closest(".member-forum-post").data("forumpostid")
        }, function(response) {
            if ($this.closest(".thank-this-member").is('[data-alreadythanked="0"]')) $this.closest(".thank-this-member").attr("data-alreadythanked", -1).find("span").text(function(index, current) {
                return parseInt(current, 10) + 1;
            });
            else $this.closest(".thank-this-member").attr("data-alreadythanked", 0).find("span").text(function(index, current) {
                console.log(current);
                return parseInt(current, 10) - 1;
            });
        });
    }));
    // allow a post to be reported
    $(".member-forum-post-wrapper").on("click", 'i[data-action="report-post"]', zeno_debounce(200, function(event) {
        //
        var $this = $(this), $popupWindow = zeno_popup_window("Report Post", zeno_template("member-forum-report-post"));
        //
        var forumTopicID = $this.closest(".member-forum-post").data("forumtopicid");
        var forumPostID = $this.closest(".member-forum-post").data("forumpostid");
        //
        $popupWindow.on("click", 'button[data-action="report-post"]', zeno_debounce(200, function(event) {
            //
            $popupWindow.find(".form-status-message").empty();
            $popupWindow.find('button[data-action="report-post"]').prop("disabled", true);
            //
            var forumReportReason = $popupWindow.find(':input[name="forumReportReason"]:checked').val();
            var forumReportMessage = $popupWindow.find(':input[name="forumReportMessage"]').val();
            //
            var successCallback = function successCallback(response) {
                zeno_confirm_window("Thank you", "Thank you for reporting this post, our moderation team will take appropriate action.", "Close", function() {
                    $popupWindow.fadeOut(300, function() {
                        $popupWindow.remove();
                    });
                });
            };
            //
            var errorCallback = function errorCallback(response) {
                //
                $popupWindow.find('button[data-action="report-post"]').prop("disabled", false);
                //
                if (typeof response.messages !== "undefined") response.messages.forEach(function(message) {
                    $popupWindow.find(".form-status-message").append("<div>" + message + "</div>");
                });
            };
            //
            zeno_ajax_request("/advice/member-forum/actions/report-post", {
                "forumTopicID": forumTopicID,
                "forumPostID": forumPostID,
                "reportReason": forumReportReason,
                "reportMessage": forumReportMessage
            }, successCallback, errorCallback);
        }));
    }));
})();

})();
//# sourceMappingURL=member-forum.min.js.map
